// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AycV","placeholdersHeader":"styles_placeholdersHeader__3MpJE","editorStyle":"styles_editorStyle__3CVEh","placeholdersBox":"styles_placeholdersBox__TTSej"};